"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VoiceCodeConstants = undefined;

var _keymirror = require("keymirror");

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoiceCodeConstants = exports.VoiceCodeConstants = (0, _keymirror2.default)({

    VOICE_CODE_FORM_REQUEST: null,
    VOICE_CODE_FORM_SUCCESS: null,
    VOICE_CODE_FORM_FAIL: null,
    VOICE_CODE_FORM_RESET: null,
    SET_TIMER: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/voice_code.js
// module id = 1883
// module chunks = 0